define.alias("checkout/components/seamless-checkout-table", "settings/components/seamless-checkout-table");